import {useContext} from 'react';
import {view} from '@sail/ui/deprecated';

import {useIntl} from 'react-intl';
import {AvailabilityNotice} from '@stripe-internal/conversations-ui';
import {EligibleChannelsEndpointResponseChannel} from '@stripe-internal/conversations-shared-dependencies';
import {Channel, ChannelType} from './Channel';
import {getDisplayChannels} from './getDisplayChannels';
import {ConfigContext} from '../../Providers/ConfigProvider';
import {Topic} from '../TopicSelector';

export type Props = {
  eligibleChannels?: EligibleChannelsEndpointResponseChannel[] | null;
  noticeMessage?: string;
  selectedTopic?: Topic;
  onChannelSelected: (channel: ChannelType) => void;
};

export function ChannelSelector({
  eligibleChannels,
  noticeMessage,
  selectedTopic,
  onChannelSelected,
}: Props) {
  const {locale} = useIntl();
  const {disableTopicSelector, audience} = useContext(ConfigContext);

  const displayChannels = getDisplayChannels({
    channels: eligibleChannels,
    selectedTopic,
    disableTopicSelector,
    locale,
    audience,
    showUnavailableChannels: true,
  });

  return (
    <view.div className="ChannelList" data-testid="ChannelList">
      {noticeMessage && <AvailabilityNotice notice={noticeMessage} />}
      {displayChannels.map((channel: ChannelType) => (
        <Channel
          key={channel.type}
          channel={channel}
          onClick={() => onChannelSelected(channel)}
        />
      ))}
    </view.div>
  );
}
